"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isFormat = function isFormat(format, date, locale) {
  return (0, _dayjs["default"])(date, format, locale || 'en', true).isValid();
};

var _default = isFormat;
exports["default"] = _default;